import en from './en'
import ar from './ar'
import hi from './hi'
import ru from './ru'
import zh from './zh'
import fr from './fr'
import de from './de'

export const translations = { en, ar, hi, ru, zh, fr, de }
